import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import {
  ManageBranchOffers,
  ManageOffers,
  ManageRestaurant,
  showMessage,
  validURL,
} from "../../Functionalities/Functions";
import AddProduct from "../Products/AddProduct";
import EditTopComponent from "../../CoreComponents/EditTopComponent";
import EditBottomComponent from "../../CoreComponents/EditBottomComponent";
import NoDataComponent from "../../CoreComponents/NoDataComponent";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import { ManageSection } from "./Logic";
import { HomeSlotSelect, HOME_SLOTS } from "./homeSlots";
import ItemSection from "../mobileLandingPage/ItemSection";
import OfferSection from "../mobileLandingPage/OfferSection";
import RestaurantSection from "../mobileLandingPage/RestaurantSection";

import AdvancedSelctionModal from "../../CoreComponents/AdvancedSelectionModal";
import HorizontalDrag from "../mobileLandingPage/HorizontalDrag";
import NoImage from "../../Assets/images/no-image.png";
import ImageUploadWithCrop from "../../CoreComponents/ImageUploadWithCrop";

function Body(props) {
  const [data, setData] = useState({
    id: "",
    name: "",
    visible_from: "",
    visible_to: "",
    bg_image: "",
    icon: "",
    url_link: "",
    is_active: "",
    is_blocked: false,
    is_branch: [],
    is_item: [],
    offer: [],

    section_type: "",
    object_type: "",
    image_type: "",
    slot: "NONE",

    branch: "",
    product: "",
    ids: [],
  });

  const [Edit, setEdit] = useState(false);
  const [noCat, setNoCat] = useState(false);
  const [loading, setloading] = useState(true);

  const [offer_items, setOffer_items] = useState([]);
  const [offer_branches, setOffer_branches] = useState([]);
  const [branches, setBranches] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [ids, setIds] = useState([]);
  const [reload, setReload] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [compression, setCompression] = useState(false);
  const [imageError, setImageError] = useState(false);

  // void 0
  useEffect(() => {
    let id = props.id;
    // void 0
    getData(id);
  }, [reload]);

  const refreshData = () => {
    // alert('ok')
    setReload(!reload);
  };

  const [type, setType] = useState("");

  const getSectionName = async (newData) => {
    // void 0
    type =
      newData.section_type === "REGULAR"
        ? newData.object_type === "ITEM"
          ? "REGULAR_ITEM"
          : "REGULAR_BRANCH"
        : newData.object_type === "ITEM"
        ? "OFFER_ITEM"
        : "OFFER_BRANCH";
    // void 0
    setType(type);
    // return type
  };

  useEffect(() => {
    // alert(JSON.stringify(ids))
    if (data.section_type === "OFFER" || data.section_type === "REGULAR") {
      // void 0
      data.section_type === "OFFER" &&
        data.object_type === "ITEM" &&
        fetchProductOfferData();
      data.section_type === "OFFER" &&
        data.object_type === "BRANCH" &&
        fetchBranchOfferData();
      data.section_type === "REGULAR" && fetchBranches();
    }
  }, [ids, searchText]);

  const getData = async (id) => {
    // exclude_list=[${ids}]
    let result = ManageSection("", "", "get", `&id=${id}`);
    await result.then((result) => {
      if (result.data.results.length) {
        setData({
          ...data,
          id: result.data.results[0].id,
          name: result.data.results[0].name,
          section_type: result.data.results[0].section_type,
          object_type: result.data.results[0].object_type,
          icon: result.data.results[0].icon && result.data.results[0].icon,
          is_active: result.data.results[0].is_active,
          is_blocked: result.data.results[0].is_blocked,
          url_link: result.data.results[0].url_link,
          visible_from: (result.data.results[0].visible_from || "").slice(0, 5),
          visible_to: (result.data.results[0].visible_to || "").slice(0, 5),

          is_branch: result.data.results[0].is_branch,
          is_item: result.data.results[0].is_item,
          offer: result.data.results[0].offer,

          section_type: result.data.results[0].section_type,
          object_type: result.data.results[0].object_type,
          image_type: result.data.results[0].image_type,
          slot: result.data.results[0].slot || "NONE",
        });

        // void 0
        let typ =
          result.data.results[0].section_type === "REGULAR"
            ? result.data.results[0].object_type === "ITEM"
              ? "REGULAR_ITEM"
              : "REGULAR_BRANCH"
            : result.data.results[0].object_type === "ITEM"
            ? "OFFER_ITEM"
            : "OFFER_BRANCH";
        // void 0

        let id_list = [];

        // await type.then((type) => {
        // void 0
        if (typ === "REGULAR_ITEM") {
          // result.data.results[0].is_items.length>0&&result.data.results[0].is_items.map((item,index)=>{
          result.data.results[0].is_items.length > 0 &&
            result.data.results[0].is_items.map((item, index) => {
              // void 0
              id_list.push(item.id);
            });
        }

        if (typ === "REGULAR_BRANCH") {
          result.data.results[0].is_branch.length > 0 &&
            result.data.results[0].is_branch.map((item, index) => {
              // void 0
              id_list.push(item.id);
            });
        }
        if (typ === "OFFER_ITEM") {
          result.data.results[0].offer.length > 0 &&
            result.data.results[0].offer.map((item, index) => {
              // void 0
              id_list.push(item.id);
            });
        }
        if (typ === "OFFER_BRANCH") {
          result.data.results[0].offer.length > 0 &&
            result.data.results[0].offer.map((item, index) => {
              // void 0
              id_list.push(item.id);
            });
        }
        // void 0

        setIds(id_list);
        setType(typ);

        // })

        setloading(false);
      } else {
        setNoCat(true);
        setloading(false);
      }

      // void 0
    });
  };

  // void 0

  const [errors, setErrors] = useState([]);

  useEffect(() => {
    if (errors.length > 0) {
      showMessage(
        errors[0],
        "danger",
        "Following fields required!",
        "top",
        "top-right",
        0
      );
    }
  }, [errors]);

  function Push(id, name) {
    // void 0

    // void 0
    // void 0
    if (!ids.includes(id)) {
      let id_list = ids;
      id_list = id_list.push(id);
      // void 0
      // void 0
      // setIds(prev => [...prev, id])
      add(
        { id: data.id, offer_id: ids },
        data.section_type === "REGULAR"
          ? data.object_type === "ITEM"
            ? "add_item"
            : "add_branch"
          : "add_offer"
      );
      // setIds(prev => [...prev, id])
      // // setSelectedData(prev => [...prev, { id: id, name: name }])
      // var x = prev => [...prev, id]
      // // var y = prev => [...prev, { id: id, name: name }]
      // showMessage("Added successfully", "info", "Success!", "top", "top-right", 0)
      // setData({ ...data, ids: ids })
      // // props.customerFunction(x)
      // // props.nameFunction(y)
      // void 0
      // void 0
    } else {
      // void 0
    }
  }

  function remove(id, keyword) {
    // void 0
    // void 0
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div
            className="custom-ui"
            style={{
              borderRadius: 8,
              border: "solid",
              padding: 70,
              borderWidth: 0.5,
            }}
          >
            <h1>Are you sure?</h1>
            <p>You want to delete ?</p>
            <button
              onClick={onClose}
              className="btn btn-primary"
              style={{ marginRight: 10 }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                onClose();
                let res = ManageSection(
                  "",
                  { id: data.id, offer_id: id },
                  keyword,
                  ""
                );
                res
                  .then((res) => {
                    if (res) {
                      showMessage(
                        "Delete success",
                        "success",
                        "Success!",
                        "top",
                        "top-right"
                      );
                      // window.location.replace("/sections");
                      getData(props.id);
                    } else {
                      showMessage(
                        "delete failed",
                        "danger",
                        "Failed!",
                        "top",
                        "top-right"
                      );
                    }
                  })
                  .catch((err) => {
                    showMessage(
                      res.data.Error,
                      "danger",
                      "Error!",
                      "top",
                      "top-right"
                    );
                  });
              }}
              className="btn btn-primary"
            >
              Delete
            </button>
          </div>
        );
      },
    });
  }

  function add(fdata, keyword) {
    // void 0
    // return 0
    let res = ManageSection(
      "",
      { id: fdata.id, offer_id: fdata.offer_id },
      keyword,
      ""
    );
    res
      .then((res) => {
        if (res) {
          showMessage(
            "Added Successfully",
            "success",
            "Success!",
            "top",
            "top-right"
          );
          // window.location.replace("/sections");
          getData(props.id);
          // setSelectedData([])
        } else {
          showMessage("Adding Failed", "danger", "Failed!", "top", "top-right");
        }
      })
      .catch((err) => {
        showMessage(res.data.Error, "danger", "Error!", "top", "top-right");
      });
  }

  // function Pop(index) {
  //   var array = selectedData
  //   var arrayid = ids

  //   void 0
  //   void 0

  //   array.splice(index, 1)

  //   arrayid.splice(index, 1)
  //   void 0
  //   void 0

  //   var x = []
  //   x = array
  //   // void 0
  //   setSelectedData([])
  //   // setData({ ...data, inner_category: [] })
  //   setIds([])

  //   array.map((arr) => {
  //     setSelectedData(prev => [...prev, { id: arr.id, name: arr.name }])
  //   })

  //   arrayid.map((arr) => {
  //     void 0
  //     setIds(prev => [...prev, arr])
  //   })
  //   console.warn("pop")
  //   setData({ ...data, ids: ids })
  //   void 0
  //   void 0
  //   void 0
  //   showMessage("removed successfully", "info", "Success!", "top", "top-right", 0)
  // }
  const setSearch = (search_text) => {
    // void 0
    setSearchText(search_text);
  };

  const fetchProductOfferData = () => {
    // showMessage("Loading offer products", "info", "Loading", "bottom", "bottom-left", 0);

    let params =
      "exclude_list=[" +
      ids +
      "]&for_dropdown=true&page_wise=false&offer_type=item&sections_offers=true&search_text=" +
      searchText;
    // void 0

    let result = ManageOffers("", "", "get", params);
    result.then((result) => {
      setOffer_items([]);
      if (result.data?.length > 0) {
        setOffer_items(result.data);

        // setData({
        //   ...data,
        //   offer_items: result.data,
        // });
        setloading(false);
      }
    });
  };
  const fetchBranchOfferData = () => {
    showMessage(
      "Loading offer restaurants",
      "info",
      "Loading",
      "bottom",
      "bottom-left",
      0
    );

    // return 0;exclude_list=['heading']&
    let params =
      "exclude_list=[" +
      ids +
      "]&for_dropdown=true&page_wise=false&offer_type=branch&sections_offers=true&search_text=" +
      searchText;
    // void 0
    let result = ManageBranchOffers("", "", "get", params);

    result.then((result) => {
      setOffer_branches([]);
      if (result.data?.length > 0) {
        setOffer_branches(result.data);

        // setData({
        //   ...data,
        //   offer_branches: result.data,
        // });
        setloading(false);
      }
      setloading(false);
    });
  };

  const fetchBranches = () => {
    // alert(JSON.stringify(ids))

    showMessage(
      "Loading Restaurant",
      "info",
      "Loading",
      "bottom",
      "bottom-left",
      0
    );

    let params =
      "exclude_list=[" +
      ids +
      "]&for_drop_down=true&blocked_out_drop_down=1&page_wise=false" +
      "&search_text=" +
      searchText;

    // void 0
    let result = ManageRestaurant("", "", "get", params);
    // setBranches([])
    result
      .then((res) => {
        if (res.data?.length > 0) {
          // void 0
          setBranches(res.data);
          // setData({
          //   ...data,
          //   branches: result.data,
          // });
          setloading(false);
        } else {
          // void 0
          setBranches(res.data);
        }
        setloading(false);
      })
      .catch((err) => {
        showMessage(
          JSON.stringify(err),
          "danger",
          "Loading error",
          "top",
          "top-center",
          0
        );
      });
  };

  // void 0

  return (
    <div class="content-body">
      <div class="container-fluid">
        {!loading ? (
          <>
            {!noCat ? (
              <>
                <EditTopComponent
                  BackButtonPath={"/sections/"}
                  DeleteButton={(e) => {
                    e.preventDefault();
                    confirmAlert({
                      customUI: ({ onClose }) => {
                        return (
                          <div
                            className="custom-ui"
                            style={{
                              borderRadius: 8,
                              border: "solid",
                              padding: 70,
                              borderWidth: 0.5,
                            }}
                          >
                            <h1>Are you sure?</h1>
                            <p>You want to delete ?</p>
                            <button
                              onClick={onClose}
                              className="btn btn-primary"
                              style={{ marginRight: 10 }}
                            >
                              Cancel
                            </button>
                            <button
                              onClick={() => {
                                let res = ManageSection(
                                  e,
                                  data,
                                  "delete",
                                  `id=${data.id}`
                                );
                                res
                                  .then((res) => {
                                    if (res) {
                                      showMessage(
                                        "Delete success",
                                        "success",
                                        "Success!",
                                        "top",
                                        "top-right"
                                      );
                                      window.location.replace("/sections");
                                    } else {
                                      showMessage(
                                        "delete failed",
                                        "danger",
                                        "Failed!",
                                        "top",
                                        "top-right"
                                      );
                                    }
                                  })
                                  .catch((err) => {
                                    showMessage(
                                      res.data.Error,
                                      "danger",
                                      "Error!",
                                      "top",
                                      "top-right"
                                    );
                                  });
                              }}
                              className="btn btn-primary"
                            >
                              Delete
                            </button>
                          </div>
                        );
                      },
                    });
                  }}
                  AddButtonName={"Add Section"}
                  AddButtonPath={"/add-section"}
                  CancelButton={(e) => {
                    e.preventDefault();
                    setEdit(false);
                    // void 0
                  }}
                  EditButton={(e) => {
                    e.preventDefault();
                    setEdit(true);
                    // void 0
                  }}
                  Edit={Edit}
                />

                <div className="col-xl-12 col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="basic-form">
                        <form>
                          {data.section_type !== "ADS" && (
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">
                                Section Name{" "}
                                <span className="required">{Edit && "*"}</span>
                              </label>
                              <div className="col-sm-9">
                                {!Edit ? (
                                  <label className="col-sm-3 col-form-label">
                                    {data.name}
                                  </label>
                                ) : (
                                  <input
                                    type="text"
                                    className="form-control"
                                    // readOnly={Edit}
                                    disabled={!Edit}
                                    value={data.name}
                                    onChange={(e) =>
                                      setData({ ...data, name: e.target.value })
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          )}

                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Show between</label>
                            <div className="col-sm-9">
                              {!Edit ? (
                                <label className="col-form-label">
                                  {data.visible_from && data.visible_to
                                    ? `${data.visible_from} to ${data.visible_to}`
                                    : "All day"}
                                </label>
                              ) : (
                                <>
                                  <div className="d-flex align-items-center" style={{ gap: 10 }}>
                                    <input
                                      type="time"
                                      className="form-control"
                                      style={{ maxWidth: 160 }}
                                      value={data.visible_from || ""}
                                      onChange={(e) =>
                                        setData({ ...data, visible_from: e.target.value })
                                      }
                                    />
                                    <span>and</span>
                                    <input
                                      type="time"
                                      className="form-control"
                                      style={{ maxWidth: 160 }}
                                      value={data.visible_to || ""}
                                      onChange={(e) =>
                                        setData({ ...data, visible_to: e.target.value })
                                      }
                                    />
                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary btn-sm"
                                      onClick={() =>
                                        setData({ ...data, visible_from: "", visible_to: "" })
                                      }
                                    >
                                      Always on
                                    </button>
                                  </div>
                                  <small className="text-muted">
                                    Leave both blank to show it all day. An end time earlier
                                    than the start time runs past midnight.
                                  </small>
                                </>
                              )}
                            </div>
                          </div>

                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Home slot</label>
                            <div className="col-sm-9">
                              {!Edit ? (
                                <label className="col-form-label">
                                  {HOME_SLOTS.find((s) => s.value === data.slot)?.label || "Not placed on new home"}
                                </label>
                              ) : (
                                <HomeSlotSelect
                                  value={data.slot}
                                  imageType={data.image_type}
                                  onChange={(slot) => setData({ ...data, slot })}
                                />
                              )}
                            </div>
                          </div>

                          {data.section_type === "ADS" && (
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">
                                URL {Edit && "(https://www.example.com)"}
                                <span className="required"></span>
                              </label>
                              <div className="col-sm-9">
                                {!Edit ? (
                                  <label className="col-form-label">
                                    {data.url_link}
                                  </label>
                                ) : (
                                  <input
                                    type="text"
                                    className="form-control"
                                    disabled={!Edit}
                                    value={data.url_link}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        url_link: e.target.value,
                                      })
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          )}

                          {!Edit ? (
                            // if not edit then show icon
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">
                                Icon <span className="required">*</span>
                              </label>
                              <div className="col-sm-9">
                                <img
                                  className="img-fluid rounded mr-3"
                                  width={85}
                                  src={
                                    data.icon
                                      ? data.icon.image
                                        ? data.icon.image
                                        : NoImage
                                      : NoImage
                                  }
                                  alt="Foodoor"
                                />
                              </div>
                            </div>
                          ) : (
                            // if edit then show add icon field
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">
                                {" "}
                                {data.section_type === "ADS"
                                  ? "Ads Image"
                                  : "Icon (33x33)"}{" "}
                                <span className="required"></span>
                                <br />
                                <b>
                                  Compress{" "}
                                  {data.section_type === "ADS"
                                    ? "image"
                                    : "icon"}{" "}
                                </b>
                                <input
                                  type="checkbox"
                                  checked={compression}
                                  onChange={(e) => {
                                    setCompression(e.target.checked);
                                    setData({ ...data, icon: "" });
                                  }}
                                />
                              </label>
                              {/* <span className="input-group-text">Upload</span> */}

                              <div className="col-sm-9">
                                <ImageUploadWithCrop
                                  value={data.icon}
                                  onChange={(file) => {
                                    if (file) {
                                      setData({ ...data, icon: file });
                                      setImageError(false);
                                    } else {
                                      setData({ ...data, icon: "" });
                                      setImageError(true);
                                    }
                                  }}
                                  aspectRatio={1}
                                  compress={compression}
                                  compressMaxRes={data.section_type === "ADS" ? 486 : 33}
                                />
                                {imageError && (
                                  <span className="required fs-14">
                                    Please change image
                                  </span>
                                )}
                              </div>
                            </div>
                          )}

                          {!Edit && (
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">
                                Section Details{" "}
                                <span className="required">{Edit && "*"}</span>
                              </label>
                              <div className="col-sm-9">
                                <label className="col-sm-3 col-form-label">
                                  {data.section_type === "ADS"
                                    ? "Advertisement "
                                    : data.section_type +
                                      " " +
                                      data.object_type}
                                  <span className="required">
                                    {Edit && "*"}
                                  </span>
                                </label>
                              </div>
                            </div>
                          )}

                          {/* Edit button when pressed edit in main page */}
                          {Edit && (
                            <EditBottomComponent
                              cancelButton={(e) => {
                                e.preventDefault();
                                setEdit(false);
                                // void 0
                              }}
                              saveButton={(e) => {
                                e.preventDefault();

                                setErrors([]);

                                if (
                                  data.name === "" &&
                                  data.section_type !== "ADS"
                                ) {
                                  setErrors(["Section name"]);
                                  return;
                                }

                                if (data.url_link && !validURL(data.url_link)) {
                                  setErrors(["Invalid Url "]);
                                  return;
                                }

                                // void 0

                                let res = ManageSection(e, data, "update", "");
                                res.then((res) => {
                                  if (res)
                                    if (res.data.Status === true) {
                                      showMessage(
                                        "Section updated",
                                        "success",
                                        "Success!",
                                        "top",
                                        "top-right",
                                        0
                                      );
                                      setEdit(true);
                                    } else {
                                      showMessage(
                                        res.data.Error,
                                        "danger",
                                        "Failed!",
                                        "top",
                                        "top-right",
                                        0
                                      );
                                    }
                                });
                              }}
                              disable={imageError}
                            />
                          )}
                        </form>

                        <hr />
                        {!Edit && (
                          <>
                            {!(
                              branches.length == 0 &&
                              offer_branches.length == 0 &&
                              offer_items.length == 0
                            ) &&
                              data.section_type !== "ADS" && (
                                <button
                                  type="button"
                                  disabled={
                                    branches.length == 0 &&
                                    offer_branches.length == 0 &&
                                    offer_items.length == 0
                                  }
                                  class="btn btn-primary light form-control mb-2 mb-2"
                                  data-toggle="modal"
                                  data-target="#AdvancedSelctionModal"
                                >
                                  Add{" "}
                                  {data.section_type === "REGULAR"
                                    ? data.object_type === "ITEM"
                                      ? "Item"
                                      : "Restaurants"
                                    : data.object_type === "ITEM"
                                    ? "Item"
                                    : "Restaurants"}
                                </button>
                              )}

                            <AdvancedSelctionModal
                              Push={Push}
                              // Pop={Pop}
                              setSearchToState={setSearch}
                              propData={
                                data.section_type === "REGULAR"
                                  ? data.object_type === "ITEM"
                                    ? []
                                    : branches
                                  : data.object_type === "BRANCH"
                                  ? offer_branches
                                  : offer_items
                              }
                              // propData={branches}

                              section_type={data.section_type}
                              object_type={data.object_type}
                              setSearch={searchText}
                            />

                            {data.section_type !== "ADS" && (
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">
                                  Preview{" "}
                                  <span className="required">
                                    {Edit && "*"}
                                  </span>
                                </label>
                              </div>
                            )}

                            {data.section_type === "OFFER" && (
                              <>
                                <OfferSection
                                  refreshData={refreshData}
                                  image_type={1}
                                  data={data}
                                  type={type}
                                  remove={remove}
                                />
                                {/* <br />
                                <OfferSection image_type={0} data={data} type={type} remove={remove} /> */}
                              </>
                            )}

                            {data.section_type === "REGULAR" && (
                              <RestaurantSection
                                refreshData={refreshData}
                                data={data}
                                remove={remove}
                              />
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <NoDataComponent data="Section" />
            )}
          </>
        ) : (
          <LoadingComponent />
        )}
      </div>
    </div>
  );
}

function Section() {
  const { id } = useParams();
  // void 0
  const headers = "Section Details";
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={headers} />
        <NavBar />
        {/* <Body bo={boln} na={name} nu={num} ar={ary} ob={obj} ao={aryobj} /> */}
        <Body id={id} />
        <Footer />
      </div>
    </div>
  );
}

export default Section;